import { render, staticRenderFns } from "./AHAudioUpload.vue?vue&type=template&id=3bcc6032&"
import script from "./AHAudioUpload.vue?vue&type=script&lang=ts&"
export * from "./AHAudioUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports